import React from "react";
import axios from "axios";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";

export const SuprCtr = ({ setSuprCtr, idSelected }) => {
  const toast = React.useRef(null);
  const apiUrl = process.env.REACT_APP_API_URL;

  const handleConfirm = () => {
    try {
      axios
        .post(`${apiUrl}IHM/api/contrat.php?idSupr=${idSelected}`)
        .then((response) => {
          toast.current.show({
            severity: 'success',
            summary: 'Succès',
            detail: `Contrat n° ${idSelected} supprimé avec succès!`,
            life: 3000
          });
          setTimeout(() => {
            setSuprCtr(false);
            window.location.reload();
          }, 1500);
        })
        .catch((error) => {
          toast.current.show({
            severity: 'error',
            summary: 'Erreur',
            detail: 'Erreur lors de la suppression',
            life: 3000
          });
        });
    } catch (error) {
      toast.current.show({
        severity: 'error',
        summary: 'Erreur',
        detail: 'Erreur lors de la suppression',
        life: 3000
      });
    }
  };

  const handleCancel = () => {
    toast.current.show({
      severity: 'info',
      summary: 'Annulé',
      detail: `Suppression du contrat n° ${idSelected} annulée`,
      life: 3000
    });
    setTimeout(() => {
      setSuprCtr(false);
    }, 1000);
  };

  const header = (
    <div className="flex justify-content-between align-items-center w-full">
      <span className="font-semibold text-lg" style={{ color: "#dc2626" }}>
        <i className="pi pi-trash" style={{ marginRight: "8px" }} />
        Supprimer le contrat
      </span>
    </div>
  );

  return (
    <>
      <Toast ref={toast} />

      <Dialog
        blockScroll
        visible={true}
        header={header}
        className="custom-dialog"
        style={{ width: "40vw", maxWidth: "500px" }}
        modal
        onHide={() => setSuprCtr(false)}
        breakpoints={{ "960px": "90vw", "640px": "95vw" }}
      >
        <div className="p-3">
         

          <div className="grid">
            <div className="col-12">
              <p style={{ fontSize: "15px", color: "#374151", textAlign: "center", marginBottom: "10px" }}>
                Voulez-vous vraiment supprimer le contrat <strong>n° {idSelected}</strong> ?
              </p>
              <p style={{ fontSize: "13px", color: "#6b7280", textAlign: "center", marginBottom: "30px" }}>
                Cette action est irréversible.
              </p>
            </div>
          </div>

          <div className="grid">
            <div className="col-12">
              <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
                <Button
                  label="Annuler"
                  icon="pi pi-times"
                  className="p-button-text"
                  style={{
                    padding: "10px 30px",
                    borderRadius: "6px",
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#6b7280",
                    border: "1px solid #d1d5db",
                    background: "white",
                  }}
                  onClick={handleCancel}
                />
                <Button
                  label="Supprimer"
                  icon="pi pi-trash"
                  style={{
                    background: "#dc2626",
                    border: "none",
                    padding: "10px 30px",
                    borderRadius: "6px",
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "white",
                  }}
                  onClick={handleConfirm}
                />
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};